/* jshint esversion: 6 */
import React from 'react';
import Modal from 'app/components/common/Modal.jsx';
import NumberPicker from "react-widgets/NumberPicker";
import { FormattedNumber } from 'react-intl';
import AddOnWidget from 'app/components/Subscription/AddOnWidget.jsx';
import * as _ from 'underscore';

class AddTweetModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            add_on_posts_1: 1
        }

        this.dismissModal = this.dismissModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);

        // if they have no extra posts, let the default go to 1
        if (this.props.currentQuantity > 1) {
            this.setState({
                add_on_posts_1: this.props.currentQuantity
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e) {

        if (e.key === "Escape") {
            this.dismissModal();
        }

    }

    dismissModal(e) {

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Dismiss Add Tweets Modal'
            });
        }
        this.props.closeAllModals();

    }

    render() {
        let modalContent = null,
            constants = this.props.app.config.constants,
            limits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                quantity: this.state.add_on_posts_1
            }]),
            buttonAction = null,
            buttonLabel = "Save changes",
            buttonClass = "add-posts",
            annualDisclaimer = null;

        if (this.state.add_on_posts_1 !== this.props.currentQuantity) {
            buttonLabel = "Save changes";
            buttonAction = this.props.addPosts;
        } else {
            buttonClass += " inactive";
        }

        const generatePostAddOnLabel = (plan, quantity) => {
            let constants = this.props.app.config.constants,
                planQuantity = 0;

            if (!_.isEmpty(this.props.plans.details)) {
                if (this.props.plans.details[plan].addOnQuantity[constants.SUBSCRIPTION_ADDON_POSTS_1] !== undefined) {
                    planQuantity = this.props.plans.details[plan].addOnQuantity[constants.SUBSCRIPTION_ADDON_POSTS_1].posts;
                }
                return (
                    <span>
                        <span className="number-callout">{quantity * planQuantity}</span> Posts
                    </span>
                );
            }

            return '';

        }

        if (this.props.user.plan.planCode.match("annual")) {
            annualDisclaimer = (
                <div>
                    <p>Extra posts reset monthly on the {moment(this.props.user.plan.nextBilling).format("Do")}.</p>
                    {this.state.add_on_posts_1 !== this.props.currentQuantity ? (
                        <p>You'll be charged a prorated amount for your updated plan.</p>
                    ) : null}
                </div>
            )
        }

        modalContent = (
            <div className="x-posts-modal">
                <div className="close-warning" onClick={this.dismissModal} aria-label='close' role="button">
                    <i className="fa fa-times"></i>
                </div>
                <div className="warning-content">
                    <h3 style={{"fontWeight": 500}}>Post more on X every month</h3>
                    <p>Extra posts are shared between all of your X accounts on dlvr.it and renew with your plan.</p>
                    <div className="x-post-wrapper">
                        <AddOnWidget
                            {...this.props}
                            labelMaker={generatePostAddOnLabel}
                            addOns={this.props.currentQuantity}
                            onQuantityChange={(plan, quantity) => {
                                this.setState({
                                    add_on_posts_1: quantity
                                })
                            }}/>

                        <FormattedNumber value={limits.addOnPostsPrice} style="currency" currency="USD"/> / {this.props.termLabel}
                    </div>
                </div>
                <div className="buttons">
                    <div className={buttonClass} onClick={() => {
                        if (buttonAction) {
                            buttonAction.apply(this, [this.state.add_on_posts_1])
                        }
                    }} role="button">
                        {buttonLabel}
                    </div>
                </div>
                <div className="annual-details">
                    {annualDisclaimer}
                </div>
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"x-posts-box"}
                mainClass={"x-posts-content"} />
        );
    }
}

AddTweetModal.displayName = "AddTweetModal";

export default AddTweetModal;
